import { ResetPasswordPage as SharedResetPasswordPage } from '@remote-medium/ui';

import { authClient } from '../../lib/auth.ts';
import { SITE_ORIGIN } from '../../lib/config.ts';

export function ResetPasswordPage() {
  return (
    <SharedResetPasswordPage
      siteUrl={SITE_ORIGIN}
      resetPassword={(newPassword, token) => authClient.resetPassword({ newPassword, token })}
    />
  );
}
